export default __webpack_public_path__ + "static/opal-crystal-8f18f6940d201bd70fd46c9f324bc002.png";